<template>
  <div :class="['wrapper', klass]">
    <textarea
      @input="autoResize"
      :class="['textarea form-input', error ? 'error-input' : '']"
      :value="value"
      :placeholder="placeholder"
      ref="textarea"
    ></textarea>
    <div ref="widthCalculator" class="width-calculator">
      {{actualValue}}
    </div>
    <div class="error-message" v-if="error">{{error}}</div>
    <div :class="[error ? 'error-message' : '', 'small-text']" >Text count: {{textCount}}</div>
  </div>
</template>
<script>
import _ from 'lodash'

export default {
  props: ["error", "value", "placeholder", "klass"],
  methods: {
    autoResize(event) {
      event.target.style.height = "auto";
      if (event.target.value) {
        this.actualValue = event.target.value
        event.target.style.height = `${event.target.scrollHeight}px`;
      } else {
        event.target.style.height = '48px';
      }

      this.$emit('update:value', event.target.value)
    },
  },
  computed: {
    textCount() {
      return _.size(this.value)
    },
  },
  data() {
    return {
      actualValue: this.value,
    }
  },
  mounted() {
    this.$nextTick(() => {
      if(this.$refs.textarea) {
        if (this.$refs.textarea.clientHeight < this.$refs.textarea.scrollHeight) {
          this.$refs.textarea.style.height = `${this.$refs.textarea.scrollHeight}px`
        } else {
          this.$refs.textarea.style.height = '40px';
        }
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.textarea {
  width: 100%;
  height: 48px;
  resize: none;
  overflow: hidden;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  outline: none;
}

.width-calculator {
  position: absolute;
  visibility: hidden;
  font-size: 16px;
  max-width: 100%;
  height: auto;
  width: auto;
}
</style>
